import { createGlobalStyle } from 'styled-components';
import cssReset from 'styles/cssReset';
import baseStyles from 'styles/baseStyles';
import themedBackgroundStyles from 'styles/themedBackgroundStyles';
var GlobalStyles = createGlobalStyle(["", " ", " html,#root,#app{height:100%;}html{overflow-y:scroll;@media (min-width:", "){font-size:", "px;}}", ""], cssReset, baseStyles, function (p) {
  return p.theme.globals.breakpoints.xxl;
}, function (p) {
  return p.theme.globals.fontSize + 3;
}, themedBackgroundStyles);
export default GlobalStyles;